import type { MapManifest } from '@/gameplay/types'
import { bunkerMap } from './bunker'
import { courtyardMap } from './courtyard'

export const MAPS: MapManifest[] = [courtyardMap, bunkerMap]

export function getMap(id: string): MapManifest | undefined {
  return MAPS.find((m) => m.id === id)
}

export { courtyardMap, bunkerMap }
